<template>
  <div class="tab-content mt-4">
    <section class="contact my-3 pt-5">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6 text-center card border-0">
            <i class="fas fa-headset fa-2x mb-3" aria-hidden="true" />
            <h6 class="text-uppercase mb-3">
              {{ trans("support.contactSupport") }}
            </h6>
            <div class="mb-3">
              <p>
                {{
                  trans("stockholmPlatform.contactTechnicalSupportDescription")
                }}
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 text-center card border-0">
            <i class="fas fa-headset fa-2x mb-3" aria-hidden="true"></i>
            <h6 class="text-uppercase mb-3">
              {{ trans("stockholmPlatform.SLSOSupport") }}
            </h6>
            <div class="mb-3">
              <p>{{ trans("stockholmPlatform.supportByPhone") }}</p>
              <p>{{ trans("stockholmPlatform.supportByEmailInstructions") }}</p>
              <p>{{ trans("stockholmPlatform.supportByEmailDescription") }}:</p>
              <p>
                <i class="fas fa-envelope fa-xs" />
                <a
                  :href="`mailto:${trans('stockholmPlatform.supportEmailAdress')}`"
                >
                  {{ trans("stockholmPlatform.supportEmailAdress") }}</a
                >
              </p>
            </div>
          </div>
          <div
            class="col-sm-12 col-md-12 col-lg-6 offset-lg-3 text-center card border-0"
          >
            <i class="fas fa-headset fa-2x mb-3" aria-hidden="true"></i>
            <h6 class="text-uppercase mb-3">
              {{ trans("stockholmPlatform.technicalSupport") }}
            </h6>
            <div class="mb-3">
              <p>
                {{ trans("stockholmPlatform.technicalSupportInstructions") }}
              </p>
              <p>
                {{ trans("stockholmPlatform.technicalSupportDescription") }}:
              </p>
              <p>
                <i class="fas fa-envelope fa-xs"></i>
                <a
                  :href="`mailto:${trans(
                    'stockholmPlatform.technicalSupportEmailAddress',
                  )}`"
                >
                  {{
                    trans("stockholmPlatform.technicalSupportEmailAddress")
                  }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="gnosco-contact-info py-5">
      <div class="row text-center mx-3">
        <div class="col-md-4 col-lg-6 mb-3">
          <img
            src="/images/dermicus-logo.svg"
            alt=""
            height="25"
            class="mb-3"
          />
          <p>
            {{ trans("support.gnoscoSupportDescription") }}
          </p>
        </div>

        <div v-if="appConfig" class="col-md-4 col-lg-6">
          <h6 class="mb-3">
            {{ trans("support.contactUs") }}
          </h6>
          <div>
            <div>{{ appConfig.company.support.phone }}</div>
            <a :href="`mailto:${appConfig.company.support.email}`">
              {{ appConfig.company.support.email }}
            </a>
            <p class="mt-2">
              {{ trans("support.gnoscoGothenburgAddress") }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { useAsyncState } from "@vueuse/core";
import { appConfigGet } from "../../../app/practitioner-portal/store/app-config";

const { state: appConfig } = useAsyncState(
  appConfigGet().then((response) => response.data),
  undefined,
);
</script>
<script>
import HeaderSupport from "../Header.vue";

export default {
  components: {
    HeaderSupport,
  },
};
</script>

<style lang="scss" scoped>
@use "/resources/assets/sass/abstracts/variables";

.card:hover i,
.card:hover h5 {
  color: variables.$dermicusBlue;
  transition: all 0.3s;
}

.tab-content {
  min-height: 90vh;
  display: flex;
  flex-direction: column;
}

.gnosco-contact-info {
  border-top: 1px solid #dee2e6;
  background-color: #f5f5f5;
  margin-top: auto;
  margin-right: -20px;
  margin-left: -20px;
  margin-bottom: -20px;
}
</style>
